import React from "react";
import "../../../css/TotalPaid.css";
import mobility from "../../../img/ride.png";

interface TotalPaidProps {
  TotalPaid: number;
}

const TotalPaid = ({ TotalPaid }: TotalPaidProps) => {
  return (
    <div className="total_paid_container">
      <div className="total_paid_display">
        <img className="mobility" src={mobility} />
        <div className="total_paid_title">累計支払金額</div>
      </div>
      <div className="total_paid_of">
        {TotalPaid.toLocaleString()}
        <span className="unit">円</span>
      </div>
    </div>
  );
};

export default TotalPaid;
